import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import { useReveal } from '../hooks/useReveal';
import teamLuisImg from '../assets/team-luis.jpg';
import teamJannikImg from '../assets/team-jannik.jpg';
import './AboutPage.css';

const FOUNDERS = [
  {
    name: 'Luis',
    role: 'Gründer & Optikermeister',
    image: teamLuisImg,
    bio: 'Luis ist Gründer und Optikermeister von Elfhalbe. Zehn Jahre Erfahrung in der Optik — und die Idee hinter Elfhalbe. Gute Sicht ist für ihn beim Skifahren entscheidend, denn er fliegt so knapp über dem Boden wie kein anderer.',
  },
  {
    name: 'Jannik',
    role: 'Gründer & Entwickler',
    image: teamJannikImg,
    bio: 'Jannik ist Co-Gründer und Entwickler von Elfhalbe. Er baut die Technologie hinter der Präzision — und setzt dabei alle Wünsche von Luis um.',
  },
];

const AboutPage: React.FC = () => {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useReveal(rootRef);

  return (
    <div className="about-page" ref={rootRef}>
      <header className="about-header">
        <div className="about-header-inner">
          <Link to="/" aria-label="ELFHALBE — zur Startseite">
            <BrandLogo height={18} withIcon />
          </Link>
          <nav className="about-nav">
            <Link to="/">Zur Startseite</Link>
            <Link to="/login" className="about-login-btn">
              Login
            </Link>
          </nav>
        </div>
      </header>

      <main>
        {/* ============ Hero ============ */}
        <section className="about-hero">
          <div className="about-hero-backdrop" />
          <div className="about-hero-scrim" />
          <div className="about-hero-content">
            <p className="eyebrow" data-reveal="">
              Über uns
            </p>
            <h1 data-reveal="">
              Wir sind
              <br />
              Elfhalbe.
            </h1>
            <p className="about-hero-sub" data-reveal="">
              Wir bringen dir die beste Sicht für die Momente, in denen es am wichtigsten ist.
            </p>
          </div>
        </section>

        {/* ============ Unser Ziel ============ */}
        <section className="about-goal">
          <div className="about-goal-grid">
            <div data-reveal="">
              <div className="accent-bar" />
              <h2>Unser Ziel</h2>
            </div>
            <div data-reveal="">
              <p className="about-goal-text">
                Schlechte Sicht nimmt dir die Freude am Wintersport. Wir bringen dir die beste
                Sicht für die Momente, in denen es am wichtigsten ist — egal ob es um das Panorama
                geht oder um die nächste Kurve.
              </p>
              <p className="about-goal-emphasis">
                Dafür kombinieren wir <span className="ice">Handwerkskunst</span> mit{' '}
                <span className="ice">modernster Technologie</span>.
              </p>
            </div>
          </div>
        </section>

        {/* ============ Die zwei Halben ============ */}
        <section className="about-founders">
          <div className="about-founders-inner">
            <div className="about-founders-head" data-reveal="">
              <p className="eyebrow">Das Gründerduo</p>
              <h2>Die zwei Halben</h2>
            </div>
            <div className="founders-grid">
              {FOUNDERS.map(f => (
                <div className="founder-card" data-reveal="" key={f.name}>
                  <div className="founder-media">
                    <img src={f.image} alt={`${f.name} — ${f.role}`} loading="lazy" />
                    <div className="founder-nameplate">{f.name}</div>
                  </div>
                  <p className="founder-role">{f.role}</p>
                  <p className="founder-bio">{f.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ============ Was macht Elfhalbe / Vision ============ */}
        <section className="about-mission">
          <div className="about-mission-grid">
            <div className="mission-card" data-reveal="">
              <div className="accent-bar" />
              <h2>Was macht Elfhalbe</h2>
              <p>
                Wir produzieren Skibrillen mit optischen Einsätzen, die perfekt auf den
                Wintersport optimiert sind.
              </p>
            </div>
            <div className="mission-card" data-reveal="">
              <div className="accent-bar accent-bar-ice" />
              <h2>Unsere Vision</h2>
              <p>
                Sport- und Schutzbrillen sollen einfach zu handhaben sein und funktionieren. Mehr
                nicht.
              </p>
            </div>
          </div>
        </section>

        {/* ============ CTA ============ */}
        <section className="about-cta">
          <div className="about-cta-inner" data-reveal="">
            <h2>Sieh, was du verpasst hast.</h2>
            <a href="/#haendler" className="btn btn-primary">
              Händler finden
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutPage;
